/* 学士学位申报流程 */ 
import Ajax from "./ajax";
import { jsToFormData } from "@/utils/func";

export const getPatch = (data) => Ajax.get(`/v1-adult-student-get-patch`, data);

export const studentDaNation = data => Ajax.get(`/v1-student-da-nation`, data); // 民族
export const studentDaProDegree = data => Ajax.get(`/v1-student-da-pro-degree`, data);  // 专业学位
export const studentDaPost = data => Ajax.post(`/v1-student-da-post`, jsToFormData(data));  // 学位数据提交

export const studentDaRecord = data => Ajax.get(`/v1-student-da-record`, data);  // 获取申请记录
